import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-approve-action-modal',
    templateUrl: './approve-action-modal.component.html',
    styleUrls: ['./approve-action-modal.component.scss'],
    standalone: false
})
export class ApproveActionModalComponent implements OnInit {
  isVisible: boolean = true;
  withRequestReview: boolean = false;
  reason: string | null = null;

  ngOnInit(): void {
  }

  constructor(public modal: NzModalRef<ApproveActionModalComponent>) {

  }

  cancel() {
    this.modal.close(null);
  }

  confirm() {
    this.modal.close({withRequestReview: this.withRequestReview, reason: this.reason});
  }

  isConfirmDisabled(): boolean {
    return this.withRequestReview && !this.reason?.trim();
  }
}
